module.exports = __webpack_public_path__ + "images/pages/for_business/pc/sec03_afd5673cb8cbe239bd58f928d6b3277b.jpg";